import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  SLICE_TIME_SHIFTER,
  THUNK_TIME_SHIFTER_OFFSET,
} from "../Constants/SliceAndThunkConstants";
import { timeShifterAPIService } from "../Services/TimeShifterService";
import { generateToken } from "./AuthorizationSlice";

const initialState = {
  response: {},
};
export const timeShifterOffset = createAsyncThunk(
  `${SLICE_TIME_SHIFTER}/${THUNK_TIME_SHIFTER_OFFSET}`,
  async (payload, { dispatch }) => {
    const response = await timeShifterAPIService(payload);
    if (response?.status === 200) {
      dispatch(generateToken());
    }
    return response;
  }
);

export const timeShifterSlice = createSlice({
  name: SLICE_TIME_SHIFTER,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(timeShifterOffset.fulfilled, (state, action) => {
      state.response = action.payload;
    });
  },
});

export default timeShifterSlice.reducer;
